import { render, staticRenderFns } from "./doughnut.vue?vue&type=template&id=0ecf39b6&scoped=true"
import script from "./doughnut.vue?vue&type=script&lang=js"
export * from "./doughnut.vue?vue&type=script&lang=js"
import style0 from "./doughnut.vue?vue&type=style&index=0&id=0ecf39b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf39b6",
  null
  
)

export default component.exports